module.exports = __webpack_public_path__ + "img/gnu_gallery5.7c22c70e.jpg";